export default __webpack_public_path__ + "static/media/bg-5.87a8e899.png";